// 修正版：画像クリック機能付きcustom-product-card.js
(function () {
  'use strict';
  
  function init() {
    console.log('修正版：カスタムカード初期化開始');
    
    // カスタム商品カード初期化
    initCustomProductCards();
    
    // 画像クリック機能初期化
    initImageClicks();
  }
  
  // カスタム商品カード機能
  function initCustomProductCards() {
    var cards = document.getElementsByClassName('custom-product-card');
    
    for (var i = 0; i < cards.length; i++) {
      var wrap = cards[i];
      
      // 重複初期化防止
      if (wrap.dataset && wrap.dataset.bound) continue;
      if (wrap.dataset) wrap.dataset.bound = 'true';
      
      // クロージャーを使用してスコープ問題を解決
      (function(currentWrap) {
        var minus = currentWrap.querySelector('.quantity-minus');
        var plus = currentWrap.querySelector('.quantity-plus');
        var input = currentWrap.querySelector('.quantity-input');
        var btn = currentWrap.querySelector('.add-to-cart-btn');
        
        var vid = currentWrap.getAttribute('data-variant-id');
        var available = currentWrap.getAttribute('data-available') === 'true';
        
        if (!vid || !input || !btn) return;
        
        // マイナスボタン
        if (minus) {
          minus.onclick = function(e) {
            e.stopPropagation();
            e.preventDefault();
            var v = parseInt(input.value || '1', 10);
            input.value = Math.max(1, v - 1);
            return false;
          };
        }
        
        // プラスボタン
        if (plus) {
          plus.onclick = function(e) {
            e.stopPropagation();
            e.preventDefault();
            var v = parseInt(input.value || '1', 10);
            input.value = v + 1;
            return false;
          };
        }
        
        // 入力フィールド
        if (input) {
          input.onclick = function(e) {
            e.stopPropagation();
          };
        }
        
        // カート追加ボタン
        if (btn) {
          btn.onclick = function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            if (!available) {
              alert('この商品は在庫切れです');
              return false;
            }
            
            var qty = parseInt(input.value || '1', 10);
            if (!qty || qty < 1) qty = 1;
            
            // ローディング表示
            var loader = currentWrap.querySelector('.cart-loading');
            if (loader) loader.style.display = 'block';
            btn.disabled = true;
            btn.textContent = '追加中...';
            
            // カート追加処理
            addToCart(vid, qty, function(success) {
              // 完了処理
              if (loader) loader.style.display = 'none';
              btn.disabled = false;
              btn.textContent = 'カートに追加';
              
              if (success) {
                alert('カートに追加しました！');
                // カート数更新（オプション）
                updateCartCount();
              } else {
                alert('カート追加に失敗しました');
              }
            });
            
            return false;
          };
        }
        
        // カードエリアのクリック制御
        currentWrap.onclick = function(e) {
          // カート関連要素のクリック時は伝播停止
          var target = e.target || e.srcElement;
          var isCartElement = target.closest('.quantity-wrapper, .add-to-cart-btn, .cart-loading') || 
                              target.tagName === 'BUTTON' || 
                              target.tagName === 'INPUT';
          
          if (isCartElement) {
            e.stopPropagation();
          }
        };
        
      })(wrap); // クロージャーでwrapを渡す
    }
  }
  
  // 画像クリック機能（新規追加）
  function initImageClicks() {
    console.log('画像クリック機能初期化');
    
    // 商品カードを取得
    var productCards = document.querySelectorAll('.card-wrapper, .grid__item, .product-card-wrapper');
    
    for (var i = 0; i < productCards.length; i++) {
      var card = productCards[i];
      
      // 商品URLを取得
      var productLink = card.querySelector('a[href*="/products/"]');
      if (!productLink) continue;
      
      var productUrl = productLink.href;
      console.log('商品URL設定:', productUrl);
      
      // 画像エリアを取得
      var mediaArea = card.querySelector('.card__media, .media');
      if (mediaArea) {
        // 既存のスタイル設定
        mediaArea.style.cursor = 'pointer';
        mediaArea.style.pointerEvents = 'auto';
        
        // クロージャーでURLを保持
        (function(url) {
          mediaArea.onclick = function(e) {
            console.log('画像クリック検出');
            
            // カート要素がクリックされた場合は無視
            var target = e.target || e.srcElement;
            if (target.closest('.custom-product-card')) {
              console.log('カート要素のため画像クリックキャンセル');
              return;
            }
            
            console.log('商品ページに移動:', url);
            window.location.href = url;
          };
        })(productUrl);
      }
      
      // 画像自体にもクリック機能を追加
      var images = card.querySelectorAll('.card__media img, .media img');
      for (var j = 0; j < images.length; j++) {
        var img = images[j];
        img.style.cursor = 'pointer';
        img.style.pointerEvents = 'auto';
        
        (function(url) {
          img.onclick = function(e) {
            console.log('画像直接クリック');
            
            if (e.target.closest('.custom-product-card')) {
              return;
            }
            
            e.preventDefault();
            e.stopPropagation();
            window.location.href = url;
          };
        })(productUrl);
      }
    }
  }
  
  // カート追加処理（分離して再利用可能に）
  function addToCart(variantId, quantity, callback) {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/add.js');
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('Accept', 'application/json');
    
    xhr.onload = function() {
      var success = xhr.status === 200;
      callback(success);
      
      if (success) {
        console.log('カート追加成功');
        // カート更新イベントを発火（他のコンポーネントに通知）
        if (document.createEvent) {
          var event = document.createEvent('Event');
          event.initEvent('cart:updated', true, true);
          document.dispatchEvent(event);
        }
      } else {
        console.log('カート追加失敗:', xhr.status);
      }
    };
    
    xhr.onerror = function() {
      console.log('カート追加ネットワークエラー');
      callback(false);
    };
    
    var requestData = JSON.stringify({
      id: variantId,
      quantity: quantity
    });
    
    xhr.send(requestData);
  }
  
  // カート数更新（オプション）
  function updateCartCount() {
    try {
      // Shopifyのカート情報を取得
      var xhr = new XMLHttpRequest();
      xhr.open('GET', '/cart.js');
      xhr.onload = function() {
        if (xhr.status === 200) {
          var cartData = JSON.parse(xhr.responseText);
          var cartCount = document.querySelector('.cart-count, [data-cart-count]');
          if (cartCount && cartData.item_count) {
            cartCount.textContent = cartData.item_count;
          }
        }
      };
      xhr.send();
    } catch (e) {
      console.log('カート数更新エラー:', e);
    }
  }
  
  // 初期化処理（複数のタイミングで実行）
  if (document.readyState === 'loading') {
    if (document.addEventListener) {
      document.addEventListener('DOMContentLoaded', init);
    } else if (document.attachEvent) {
      document.attachEvent('onreadystatechange', function() {
        if (document.readyState === 'complete') init();
      });
    }
  } else {
    init();
  }
  
  // フォールバック初期化
  setTimeout(init, 500);
  setTimeout(init, 1500);
  
  // Shopify特有のイベント対応
  if (document.addEventListener) {
    try {
      document.addEventListener('shopify:section:load', function() {
        setTimeout(init, 100);
      });
      document.addEventListener('shopify:section:reorder', function() {
        setTimeout(init, 100);
      });
    } catch (e) {
      console.log('Shopifyイベント設定エラー（Sandbox制限）:', e);
    }
  }
  
  // グローバル関数として公開
  if (typeof window !== 'undefined') {
    window.initCustomProductCards = init;
    window.debugImageClicks = function() {
      console.log('画像クリックデバッグモード');
      var images = document.querySelectorAll('.card__media, .media');
      for (var i = 0; i < images.length; i++) {
        images[i].style.border = '2px solid red';
        images[i].style.background = 'rgba(255,0,0,0.1)';
      }
    };
  }
})();
